import { createFileRoute } from '@tanstack/react-router';

import { ShopProductDetail } from '@/features/shop/ShopProductDetail';

export const Route = createFileRoute('/_authenticated/shop/$productId')({
  component: function ShopProductDetailPage() {
    const { productId } = Route.useParams();
    return <ShopProductDetail productId={productId} />;
  },
});
